import React from 'react';

import { CircleIcon } from '@tanium/react-composed-icons';
import styled from '@tanium/react-emotion-9';
import { InfoIcon } from '@tanium/react-graphics';
import { ThemeDefinition, useThemeDefinition } from '@tanium/react-theme-definition';
import { SimpleTooltip } from '@tanium/react-tooltip';

export interface BadgeInfoIconProps {
  bg: ThemeDefinition;
  color: ThemeDefinition;
  tooltipContent: React.ReactNode;
}

const StyledCircleIcon = styled(CircleIcon)({ display: 'block' });

export const BadgeInfoIcon = ({ bg, color, tooltipContent }: BadgeInfoIconProps): JSX.Element => {
  const [realBg, realColor] = useThemeDefinition([bg, color]);

  return (
    <SimpleTooltip content={tooltipContent} placement="top">
      {({ ref }: { ref: React.Ref<HTMLDivElement> }) => (
        <div ref={ref}>
          <StyledCircleIcon
            icon={InfoIcon}
            outerRadius={8}
            innerRadius={5}
            backgroundColor={realColor}
            iconColor={realBg}
          />
        </div>
      )}
    </SimpleTooltip>
  );
};
